import * as React from "react";

import type { ITheme } from "@fluentui/react/lib/Styling";

import type { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";
import { AppPreviewGallery, getAppGalleryStyles } from "@1js/acui-gallery";
import { AppThemeConsumer } from "@1js/acui-theme";

import type { AppIconGalleryButtonProps } from "../AppIconFullGalleryButton";
import { AppIconPreviewGalleryButton } from "../AppIconPreviewGalleryButton";
import type { AppIconPreviewGalleryProps } from "./AppIconPreviewGallery.Props";
import { getIconPreviewGalleryStyles } from "./AppIconPreviewGallery.styles";

export class AppIconPreviewGallery extends React.PureComponent<
  AppIconPreviewGalleryProps &
    AppPreviewGalleryInternalProps<AppIconGalleryButtonProps>,
  {}
> {
  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppPreviewGallery
            {...this.props}
            styles={getAppGalleryStyles(
              theme,
              getIconPreviewGalleryStyles(theme, this.props.styles)
            )}
            getGalleryButtonComponent={AppIconPreviewGalleryButton}
            automationType={
              this.props.dataAutomationType || "AppIconPreviewGallery"
            }
            uniqueId={this.props.id}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
export default AppIconPreviewGallery;
